import { render, staticRenderFns } from "./ui-tabs.vue?vue&type=template&id=6b38dbe4&scoped=true&"
import script from "./ui-tabs.vue?vue&type=script&lang=ts&"
export * from "./ui-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./ui-tabs.vue?vue&type=style&index=0&id=6b38dbe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b38dbe4",
  null
  
)

export default component.exports